import {
  CIVILMATERIALCATEGORY_LOADING,
  GET_CIVILMATERIALCATEGORY,
  GET_CIVILMATERIALCATEGORY_SUCCESS,
  GET_CIVILMATERIALCATEGORY_FAIL,
  ADD_CIVILMATERIALCATEGORY_SUCCESS,
  ADD_CIVILMATERIALCATEGORY_FAIL,
  DELETE_CIVILMATERIALCATEGORY_SUCCESS,
  DELETE_CIVILMATERIALCATEGORY_FAIL,
  UPDATE_CIVILMATERIALCATEGORY_SUCCESS,
  UPDATE_CIVILMATERIALCATEGORY_FAIL,
  CIVILMATERIALCATEGORY_RESET
} from "./actionType";

const INIT_STATE = {
  civilAccountCategories: [],
  error: {},
};

const CivilAccountCategory = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_CIVILMATERIALCATEGORY_SUCCESS:
      switch (action.payload.actionType) {
        case GET_CIVILMATERIALCATEGORY:
          return {
            ...state,
            civilAccountCategories: action.payload.data,
            isCivilAccountCategoryCreated: false,
            isCivilAccountCategorySuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_CIVILMATERIALCATEGORY_FAIL:
      switch (action.payload.actionType) {
        case GET_CIVILMATERIALCATEGORY_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isCivilAccountCategoryCreated: false,
            isCivilAccountCategorySuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_CIVILMATERIALCATEGORY: {
      return {
        ...state,
        isCivilAccountCategoryCreated: false,
        loading: true,
      };
    }

    case CIVILMATERIALCATEGORY_LOADING: {
      return {
        ...state,
        isCivilAccountCategoryCreated: false,
        loading: true,
      };
    }

    case ADD_CIVILMATERIALCATEGORY_SUCCESS:
      return {
        ...state,
        isCivilAccountCategoryCreated: true,
        loading: false,
        civilAccountCategories: [action.payload.data, ...state.civilAccountCategories],
      };

    case ADD_CIVILMATERIALCATEGORY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_CIVILMATERIALCATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        civilAccountCategories: state.civilAccountCategories.filter(
          civilCivilAccountCategory => civilCivilAccountCategory.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_CIVILMATERIALCATEGORY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_CIVILMATERIALCATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        civilAccountCategories: state.civilAccountCategories.map(civilCivilAccountCategory =>
          civilCivilAccountCategory.id.toString() === action.payload.data.id.toString() ? { ...civilCivilAccountCategory, ...action.payload.data } : civilCivilAccountCategory
        ),
      };

    case UPDATE_CIVILMATERIALCATEGORY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case CIVILMATERIALCATEGORY_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default CivilAccountCategory;